import type { AnalyticsReportTab } from "./autoExportMappers";

export const REPORT_OPTIONS: ReadonlyArray<{
  value: AnalyticsReportTab;
  label: string;
}> = [
  { value: "overview", label: "Overview Report" },
  { value: "revenue", label: "Revenue report" },
  { value: "services", label: "Services report" },
  { value: "offers", label: "Offers report" },
  { value: "operations", label: "Operations report" },
  { value: "reviews", label: "Reviews report" },
  { value: "teams", label: "Teams report" },
] as const;

export const PERIOD_OPTIONS = [
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
] as const;

export const DEFAULT_EMAIL_TITLE = "Automatic email with analytics";

export const DEFAULT_EMAIL_DESCRIPTION =
  "Congratulations! I am sending you an automatic update with up-to-date analytics for the reporting period...";
